import React, { useCallback, useContext, useState } from 'react';
import { Segmented, Typography } from 'antd';
import { AuthContext } from 'util/Auth';
import { PermissionsContext } from 'util/PermissionsContext';
import TriggerRunCard from './TriggerRunCard';
import RunsList from './RunsList';
import RunDetail from './RunDetail';
import StaffView from './StaffView';
import './Segmentation.less';

const { Paragraph } = Typography;

const VIEW_OPTIONS = [
  { label: 'Admin', value: 'admin' },
  { label: 'Staff view', value: 'staff' },
];

const Segmentation = () => {
  const { currentUser } = useContext(AuthContext);
  const { permissions } = useContext(PermissionsContext);
  const canAdmin = !!currentUser?.admin
    || (Array.isArray(permissions) && permissions.includes('segmentation'));
  const [view, setView] = useState('admin');
  const [selectedRunId, setSelectedRunId] = useState(null);

  const onRunsCreated = useCallback((runs) => {
    if (runs?.length) setSelectedRunId(runs[0].id);
  }, []);

  if (!canAdmin) {
    return (
      <div id="segmentation-page">
        <StaffView />
      </div>
    );
  }

  const viewToggle = (
    <Segmented
      className="segmentation-view-toggle"
      options={VIEW_OPTIONS}
      value={view}
      onChange={setView}
    />
  );

  if (view === 'staff') {
    return (
      <div id="segmentation-page">
        {viewToggle}
        <StaffView />
      </div>
    );
  }

  if (selectedRunId != null) {
    return (
      <div id="segmentation-page">
        <RunDetail runId={selectedRunId} onBack={() => setSelectedRunId(null)} />
      </div>
    );
  }

  return (
    <div id="segmentation-page">
      {viewToggle}
      <Paragraph type="secondary" className="segmentation-intro">
        Trigger NZ/AU trade re-segmentation, review the segment spread as a human check,
        then apply the changes to Cin7 and Monday.
      </Paragraph>
      <TriggerRunCard onRunsCreated={onRunsCreated} />
      <RunsList onSelectRun={setSelectedRunId} />
    </div>
  );
};

export default Segmentation;
